
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBuoySuperLandby as ObiBuoySuperLandbyElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-buoy-super-landby.js';
 
 
 

 
 export const ObiBuoySuperLandby = createComponent({
   react: React,
   tagName: 'obi-buoy-super-landby',
   elementClass: ObiBuoySuperLandbyElement,
   events: {
     
   }
  });
 
 